<template>
    <v-app>
        <router-view>
        </router-view>
    </v-app>
</template>

<script>

import Vue from 'vue'
import LongPress from './components/LongPress.js'

Vue.directive('longpress', LongPress)

export default {
    name: 'App',

    components: {
    },

    data: () => ({
    }),

    methods: {
    },
    computed: {
    },
    mounted: function () {
    }
};
</script>

<style>

body {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10+ and Edge */
  user-select: none; /* Standard syntax */
}

.selectable {
  -webkit-user-select: auto !important; /* Safari */
  -ms-user-select: auto !important; /* IE 10+ and Edge */
  user-select: auto !important; /* Standard syntax */
}

.v-item-group.v-bottom-navigation .v-btn {
    height: inherit !important;
}

.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes shake {
  from, to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  from, to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%, 30%, 50%, 70%, 90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%, 40%, 60%, 80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

.shake {
  -webkit-animation-name: shake;
  animation-name: shake;
}
</style>
